import * as type from './types';
import { createReducer } from "../../util/index";

const initialState = 
{
    data: [],
};

const rebateSettingReducer = createReducer(initialState) ({
    //Export the response to the react.js to get the response data based on type name
    [type.LIST]: (state, action) => ({
        ...state,
        rs: action.value,
    }),
    [type.UPDATE_STATUS]: (state, action) => ({
        ...state,
        updateStatus: action.value,
    }),
    [type.DETAILS]: (state, action) => ({
        ...state,
        details: action.value,
    }),
    [type.UPDATE_SETTING]: (state, action) => ({
        ...state,
        updateSetting: action.value,
    }),
});

export default rebateSettingReducer;